// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialogContent_Baagl.desktop_JU0Bt {
  max-height: var( --size-dialogMaxHeight, 80vh );
  max-width: var( --size-dialogMaxWidth, 80vw );
}
.dialogText_FfzW0 {
  width: 100px;
  text-align: center;
}
.dialogMain_mCPEy {
  background-color: var(--color-white);
}
.dialogMain_mCPEy.desktop_JU0Bt {
  border-radius: 8px;
  box-shadow: 0 8px 16px var(--color-shadowBase), 0 0px 1px var(--color-shadowBase);
  max-height: 90vh;
}
.dialogMain_mCPEy.mobile_nDazB, .dialogContent_Baagl.mobile_nDazB {
  height : 100%;
}
.noSize_G7IcH.win_MVF9r.really_ka2ab {
  height: unset;
  width: unset;
  background-color: var( --color-base050 );
}

.emptyValue_qZ45k.win_MVF9r.really_ka2ab {
  color : var( --color-base300 )
}

.parent_qceq_ {
  position: relative;
  overflow: hidden;
}

.child_tK0hD.common_EuU09 {
  position: absolute;
  background-color: #000000;
  opacity: 0.5;
  color : white;
  font-size: 13px;
}

.parent_qceq_:hover .child_tK0hD.win_MVF9r, .parent_qceq_:focus .child_tK0hD.win_MVF9r {
  visibility: visible;
}

.child_tK0hD.win_MVF9r {
  visibility: hidden;
  font-weight: 600;
}

.child_tK0hD.win_MVF9r:hover, .child_tK0hD.win_MVF9r:focus {
  background-color: #000000;
  opacity: 0.7;
}

.left_mVt4J.win_MVF9r {
  border-radius: 0 16px 16px 0;
  left : 0;
  padding : 12px 8px;
  top : calc( 50% - 21px );
}

.right_JaqCD.win_MVF9r {
  border-radius: 16px 0 0 16px;
  right : 0;
  padding : 12px 8px;
  top : calc( 50% - 21px );
}

.parent_qceq_:hover .count_uCLly.common_EuU09, .parent_qceq_:focus .count_uCLly.common_EuU09 {
  visibility: hidden;
}

.count_uCLly.common_EuU09 {
  right : 4px;
  bottom : 4px;
  padding : 4px 8px;
  border-radius : 8px
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/imagine/attributes/image/imageList/resourceImage/Renderer.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,6CAA6C;AAC/C;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,iFAAiF;EACjF,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,QAAQ;EACR,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;AACF","sourcesContent":[".dialogContent.desktop {\n  max-height: var( --size-dialogMaxHeight, 80vh );\n  max-width: var( --size-dialogMaxWidth, 80vw );\n}\n.dialogText {\n  width: 100px;\n  text-align: center;\n}\n.dialogMain {\n  background-color: var(--color-white);\n}\n.dialogMain.desktop {\n  border-radius: 8px;\n  box-shadow: 0 8px 16px var(--color-shadowBase), 0 0px 1px var(--color-shadowBase);\n  max-height: 90vh;\n}\n.dialogMain.mobile, .dialogContent.mobile {\n  height : 100%;\n}\n.noSize.win.really {\n  height: unset;\n  width: unset;\n  background-color: var( --color-base050 );\n}\n\n.emptyValue.win.really {\n  color : var( --color-base300 )\n}\n\n.parent {\n  position: relative;\n  overflow: hidden;\n}\n\n.child.common {\n  position: absolute;\n  background-color: #000000;\n  opacity: 0.5;\n  color : white;\n  font-size: 13px;\n}\n\n.parent:hover .child.win, .parent:focus .child.win {\n  visibility: visible;\n}\n\n.child.win {\n  visibility: hidden;\n  font-weight: 600;\n}\n\n.child.win:hover, .child.win:focus {\n  background-color: #000000;\n  opacity: 0.7;\n}\n\n.left.win {\n  border-radius: 0 16px 16px 0;\n  left : 0;\n  padding : 12px 8px;\n  top : calc( 50% - 21px );\n}\n\n.right.win {\n  border-radius: 16px 0 0 16px;\n  right : 0;\n  padding : 12px 8px;\n  top : calc( 50% - 21px );\n}\n\n.parent:hover .count.common, .parent:focus .count.common {\n  visibility: hidden;\n}\n\n.count.common {\n  right : 4px;\n  bottom : 4px;\n  padding : 4px 8px;\n  border-radius : 8px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogContent": `dialogContent_Baagl`,
	"desktop": `desktop_JU0Bt`,
	"dialogText": `dialogText_FfzW0`,
	"dialogMain": `dialogMain_mCPEy`,
	"mobile": `mobile_nDazB`,
	"noSize": `noSize_G7IcH`,
	"win": `win_MVF9r`,
	"really": `really_ka2ab`,
	"emptyValue": `emptyValue_qZ45k`,
	"parent": `parent_qceq_`,
	"child": `child_tK0hD`,
	"common": `common_EuU09`,
	"left": `left_mVt4J`,
	"right": `right_JaqCD`,
	"count": `count_uCLly`
};
export default ___CSS_LOADER_EXPORT___;
